<div class="content">
  <img src="../../../assets/images/abou-page-logo.png" alt="" />
  <h2 class="title">环球巴士</h2>
  <p class="description">全球优质互联网服务一站式合租平台</p>
  <article>
    <p>
      杭州十全信息科技有限公司成立于2019年7月，原名奈飞站。我们主营会员合租、代充值和多项便捷服务，涉及影视、音乐、游戏、办公等领域。
    </p>
    <p>
      作为行业先驱，我们率先推出了“拼车”合租的概念，让用户体验到稳定、便捷的会员服务。我们提供在线客服1对1耐心解答和指导，以确保用户在使用我们的服务时享受全方位的支持。我们本着以服务为中心的理念，将客户视为朋友，将产品视为生命。
    </p>
    <p>
      多年以来，我们始终秉持自主采购的原则，不曾妥协于低价的诱饵和不稳定的产品和服务；我们坚持通过自主运营获客，不过度依赖分佣推广，避免将成本转嫁到用户；我们也一直坚持提供一对一在线服务，因为我们深刻的理解用户。
    </p>
    <p>
      通过我们的不懈努力，环球巴士的用户数量从零增长到超过10万，服务范围由最初的奈飞会员合租扩大到近20种服务。我们时刻关注用户的需求和反馈，推出个性化、贴心化的服务和产品，以提高用户的使用体验和价值。
    </p>
    <p>
      我们秉持对用户负责的态度，努力为用户提供高品质、高稳定的产品和服务。我们也将继续创新和发展，为用户提供更便捷、更优质的服务和产品。
      感恩每一次信任！让我们共同迎接更美好的未来。
    </p>
  </article>

  <div class="agreement">
    <a class="user" routerLink="/agreement">用户协议</a>
    <a routerLink="/privacy">隐私政策</a>
  </div>
</div>
